import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { UserDTO } from '../model/UserDTO';
import { map } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';
import { ClientDTO } from '../model/ClientDTO';
import { UserProfileDTO } from '../model/UserProfileDTO';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private BASE_URL = '/User';
  private LOGIN = '/login';
  private REGISTER = '/register';
  private RESET_TOKEN = '/resetToken';
  private UPDATE_PROFILE = '/profile';
  private GET_PROFILE = '/getProfile';

  constructor(private http: HttpService) { }

  getProfile() {
    return this.http.get<any>(this.BASE_URL + this.GET_PROFILE).pipe(
      map(response => {
        return response;
      })
    );
  }

  login(email: string, password: string) {
    let body = {
      email: email,
      password: password
    }
    return this.http.post<UserDTO>(this.BASE_URL + this.LOGIN, null, body, false).pipe(
      map(response => {
        var obj = new UserDTO();
        obj.fillFromJSON(response);
        return obj;
      })
    );
  }

  resetToken() {
    return this.http.post<any>(this.BASE_URL + this.RESET_TOKEN, null, null, true);
  }

  setClient(client: ClientDTO) {
    return this.http.post<UserDTO>(this.BASE_URL + '/' + client.id.toString(), null, null).pipe(
      map(response => {
        var obj = new UserDTO();
        obj.fillFromJSON(response);
        return obj;
      })
    );
  }

  register(data: any) {
    return this.http.post<UserDTO>(this.BASE_URL + this.REGISTER, null, data, false).pipe(
      map(response => {
        var obj = new UserDTO();
        obj.fillFromJSON(response);
        return obj;
      })
    );;
  }

  updateProfile(data: UserProfileDTO): Observable<any> {
    return this.http.put<any>(this.BASE_URL + this.UPDATE_PROFILE, data);
  }

}
